import React, { useEffect } from "react";

function useFormCalculationWarnings(
  validationWarnings: string | Array<string>
) {
  const [state, setState] = React.useState<Array<string>>([]);

  const getSeparatingIcon = (warning: string): string => {
    if (warning.includes("●")) return "●";
    else if (warning.includes("•")) return "•";
    else return "●";
  };

  useEffect(() => {
    if (!validationWarnings) return;

    if (typeof validationWarnings === "string") {
      const warnings = validationWarnings
        .split(getSeparatingIcon(validationWarnings))
        .map((x) => x.trim())
        .filter((x) => x);

      setState(warnings);
    } else {
      setState(validationWarnings);
    }
  }, [validationWarnings]);

  return state;
}

export default useFormCalculationWarnings;
